import { Compass } from "lucide-react";
import Card from "../../components/ui/Card";
import EmptyState from "../../components/ui/EmptyState";

/**
 * Landing for a direct visit to "/". There is no app catalogue here — every
 * screen needs an app and an account, and both only arrive from the CRM.
 */
const NoContext = () => (
  <Card padded={false} className="anim-in">
    <EmptyState
      tone="violet"
      icon={<Compass size={24} />}
      title="Open this from your CRM"
      description="App pages are opened from inside your CRM account, which is where the app and location come from. There's nothing to browse here directly."
    />
  </Card>
);

export default NoContext;
